module.exports = {"id":"220198","name":"Bersant Celina","rating":"71","photo":"./data/images/photos/1/220198.png","club":{"name":"Ipswich Town","logo":"./data/images/clubs/IpswichTown.png"},"positions":["MG","AG","AD","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BersantCelina0.json
// module id = 595
// module chunks = 0